<template>
  <!-- Main Site -->
  <MainSite v-if="theme.subdomain === 'main'" :theme="theme" />
  
  <!-- Coffee Site -->
  <CoffeeSite v-else-if="theme.subdomain === 'coffee'" :theme="theme" />
  
  <!-- Fisheries Site -->
  <FisheriesSite v-else-if="theme.subdomain === 'fisheries'" :theme="theme" />
  
  <!-- Fruit Site -->
  <FruitSite v-else-if="theme.subdomain === 'fruit'" :theme="theme" />
  
  <!-- Bitter Melon Site -->
  <BitterMelonSite v-else-if="theme.subdomain === 'bittermelon'" :theme="theme" />
  
  <!-- Halal Site -->
  <HalalSite v-else-if="theme.subdomain === 'halal'" :theme="theme" />
  
  <!-- Mulberry Site -->
  <MulberrySite v-else-if="theme.subdomain === 'mulberry'" :theme="theme" />
  
  <!-- Cluster Site -->
  <ClusterSite v-else-if="theme.subdomain === 'cluster'" :theme="theme" />
  
  <!-- Default fallback to Main Site -->
  <MainSite v-else :theme="theme" />

  <!-- Content slot for child pages -->
  <slot />
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'

// Define props to receive theme data from parent
const props = defineProps({
  theme: {
    type: Object,
    default: () => ({})
  }
})

// Lazy load site components
const MainSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/MainSite.vue'))
const CoffeeSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/CoffeeSite.vue'))
const FisheriesSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/FisheriesSite.vue'))
const FruitSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/FruitSite.vue'))
const BitterMelonSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/BitterMelonSite.vue'))
const HalalSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/HalalSite.vue'))
const MulberrySite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/MulberrySite.vue'))
const ClusterSite = defineAsyncComponent(() => import('~/layouts/theme/custom/clustersie/sites/ClusterSite.vue'))

// Log received theme for debugging
console.log('Received Theme Config:', props.theme)
console.log('Current Subdomain from theme:', props.theme.subdomain)
</script>

<style scoped>
/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Custom animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

/* Gradient text effect */
.gradient-text {
  background: linear-gradient(135deg, #10b981, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Glass morphism effect */
.glass-effect {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
</style>